import { v4 } from 'uuid';

export function _regxp() {
	const regxp = {};
	regxp.zipCode = /\d{5}/;
	regxp.number = /\d/;
	regxp.numbers = /\d+/;
	// https://emailregex.com/
	// regxp.email = /^([^.@]+)(\.[^.@]+)*@([^.@]+\.)+([^.@]+)$/;
	regxp.email = /^(([^<>()\\.,;:\s@"]+(\.[^<>()\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]{2,}\.)+[a-zA-Z]{2,}))$/;
	regxp.phone = /^[+]?(\d+[-/()\s]*)+/;
	regxp.domain = /^(ht{2}ps*:\/\/)*(www.)*([a-zA-Z0-9-])+(\.[a-zA-Z0-9-]{2,})+(\/[a-zA-Z0-9-]*)*$/;
	regxp.time = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/;
	return regxp;
}

export function validateForm($refs) {
	let isValid = true;
	if ($refs) {
		for (const key in $refs) {
			const baseInput = $refs[key];
			if (baseInput && baseInput.validate) {
				baseInput.validate();
				isValid = isValid && baseInput.isValid;
			}
		}
	}

	return isValid;
}

export function getPersonTitlesOptions() {
	return [
		{ display: 'Herr', value: 'male' },
		{ display: 'Frau', value: 'female' },
		{ display: 'Firma', value: 'company' },
	];
}

export function getOptionsForValuesArray(options) {
	const array = [];
	for (let i = 0; i < options.length; i++) {
		array.push({ display: options[i], value: options[i] });
	}
	return array;
}

export function getOptionFromOptionsArray(options, value) {
	return options.filter(option => option.value === value)[0];
}

export function getPersonNameTitlesOptions() {
	return [
		{ display: 'Prof.', value: 'prof' },
		{ display: 'Dr.', value: 'dr' },
	];
}

export function getYesNoOptions() {
	return [
		{ display: 'Ja', value: true },
		{ display: 'Nein', value: false },
	];
}

export function getHourOptions() {
	return [
		{ display: '06', value: 6 },
		{ display: '07', value: 7 },
		{ display: '08', value: 8 },
		{ display: '09', value: 9 },
		{ display: '10', value: 10 },
		{ display: '11', value: 11 },
		{ display: '12', value: 12 },
		{ display: '13', value: 13 },
		{ display: '14', value: 14 },
		{ display: '15', value: 15 },
		{ display: '16', value: 16 },
		{ display: '17', value: 17 },
		{ display: '18', value: 18 },
		{ display: '19', value: 19 },
		{ display: '20', value: 20 },
		{ display: '21', value: 21 },
		{ display: '22', value: 22 },
		{ display: '23', value: 23 },
		{ display: '00', value: 0 },
		{ display: '01', value: 1 },
		{ display: '02', value: 2 },
		{ display: '03', value: 3 },
		{ display: '04', value: 4 },
		{ display: '05', value: 5 },
	];
}

export function getMinutesOptions() {
	return [
		{ display: '00', value: 0 },
		{ display: '05', value: 5 },
		{ display: '10', value: 10 },
		{ display: '15', value: 15 },
		{ display: '20', value: 20 },
		{ display: '25', value: 25 },
		{ display: '30', value: 30 },
		{ display: '35', value: 35 },
		{ display: '40', value: 40 },
		{ display: '45', value: 45 },
		{ display: '50', value: 50 },
		{ display: '55', value: 55 },
	];
}

export function getPersonTitlesOption(value) {
	const options = getPersonTitlesOptions();
	return getOptionFromOptionsArray(options, value);
}

export function getYesNoOption(value) {
	const options = getYesNoOptions();
	const _value = value ? true : false;
	return getOptionFromOptionsArray(options, _value);
}

export function getTimeWithLeadingNull(time) {
	return ('0' + time).slice(-2);
}

export function getStringFromDate(date, formatter = null) {
	if (!date) return null;
	if (!isNaN(date) && typeof date !== 'object') {
		// if is unix timestamp
		date = new Date(date * 1000);
	}
	const day = getTimeWithLeadingNull(date.getDate());
	const month = getTimeWithLeadingNull(date.getMonth() + 1);
	const year = date.getFullYear();
	if (formatter) {
		return formatter({ day, month, year });
	}
	return [day, month, year].join('.');
}

export function getTimeFromDate(date) {
	return getTimeWithLeadingNull(date.getHours()) + ':' + getTimeWithLeadingNull(date.getMinutes());
}

export function getUnixTimestamp(date = new Date()) {
	return Math.round(date.getTime() / 1000);
}

export function parseGermanDate(input) {
	const parts = input.match(/(\d+)/g);
	// note parts[1]-1
	let year = parts[2];
	if (parts[2].length === 2) {
		year = Number(parts[2]) + 2000;
	}
	return new Date(year, parts[1] - 1, parts[0]);
}

export function getGermanDate(date) {
	const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
	return new Date(date).toLocaleDateString('de-DE', options);
}

export function getGermanDateTime(date) {
	const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
	return new Date(date).toLocaleTimeString('de-DE', options);
}

export function getRegularDate() {
	const date = new Date();
	const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
	const month = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
	const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
	return `${year}${month}${day}`;
}

export function concatArray(values) {
	let result = '';
	values.forEach(value => {
		if (value) {
			result += ' ' + value.trim();
		}
	});
	return result.trim();
}

export function getYesOrNoFromBool(is) {
	return is ? 'Ja' : 'Nein';
}

export function setCharAt(str, index, chr) {
	if (index > str.length - 1) return str;
	return str.substring(0, index + 1) + chr + str.substring(index + 1);
}

export function makeShadowCopy(obj) {
	return { ...obj, _shadow: obj };
}

export function getShadowCopy(obj) {
	return { ...obj };
}

export function isSameObject(one, two) {
	return JSON.stringify(one) === JSON.stringify(two);
}

export function makeShadowCopyFromArrayElements(array) {
	for (let i = 0; i < array.length; i++) {
		array[i] = makeShadowCopy(array[i]);
	}

	return array;
}

export function emptyCatch(error) {
	// error
}

export function insertUUIDinArrayElements(array) {
	array.map(element => (element.uuid = v4()));
}

export function uniqueScheduleProcess(callback) {
	return {
		id: null,
		callback() {
			clearTimeout(this.id);
			this.id = setTimeout(callback, 300);
		},
	};
}

export function addDaysToDate(days, date) {
	const msStart = date.getTime();
	const msDifference = days * 24 * 60 * 60 * 1000;
	const msEnd = msStart + msDifference;

	return new Date(msEnd);
}

export function uppercaseChar(s, charAt = 0) {
	const before = s.substr(0, charAt);
	const char = s.substr(charAt, 1).toUpperCase();
	const after = s.substr(charAt + 1, s.length);

	return before + char + after;
}

export function tryParseInt(x) {
	const parsed = parseInt(x);
	if (isNaN(parsed)) {
		return null;
	}
	return parsed;
}

export function findGetParameter(parameterName) {
	let result = null;
	let tmp = [];
	location.search
		.substr(1)
		.split('&')
		.forEach(function(item) {
			tmp = item.split('=');
			if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
		});
	return result;
}

export function getDamageCaseLabel(damageCaseType, vehicleLicensePlate, date) {
	let label = '';
	switch (damageCaseType) {
		case 'comprehensive':
			label = 'Kasko-Vorgang';
			break;
		case 'liability':
			label = 'Haftpflicht-Vorgang';
			break;
		case 'order_documentation':
			label = 'Auftragsdokumentation';
			break;
	}
	if (date) {
		return label + ' vom ' + date + ' - ' + vehicleLicensePlate;
	} else {
		return label + ' - ' + vehicleLicensePlate;
	}
}
